import { createFileRoute, redirect } from '@tanstack/react-router';
import { UserRole } from '@ata-digital/client-tax-system-api-client';
import { AuditAdminDashboard } from '@/features/preparer/admin/AuditAdminDashboard';
import type { AuthState } from '@/hooks/auth/useAuth';

export const Route = createFileRoute('/preparer/audit-admin-dashboard')({
  beforeLoad: ({ context }) => {
    // A fresh page load has no cached auth yet, so it passes through to PreparerAuthGuard
    const authState = (
      context as { queryClient: { getQueryData: (key: string[]) => unknown } }
    ).queryClient.getQueryData(['auth', 'session']) as AuthState | undefined;
    if (authState?.isAuthenticated && authState?.user?.role !== UserRole.Admin) {
      throw redirect({ to: '/preparer' });
    }
  },
  component: AuditAdminDashboard,
});
